import { Number } from '../../common';

export const Area = (props) => {
  return <Number {...props} compact={false} />;
};

